import { ArtifactType } from "@/enums/ArtifactType";
import api from "@/api";
import ClipboardWarning from "@/components/ClipboardWarning.vue";
import { calculateTimeout } from "./utilities";
interface Artifact {
	id: string;
	conversationId?: string;
}

interface ArtifactTypeConfig {
	singularName: string;
	pluralName: string;
}

const artifactConfigs: Record<ArtifactType, ArtifactTypeConfig> = {
	[ArtifactType.Snapshots]: {
		singularName: "photo",
		pluralName: "photos",
	},
	[ArtifactType.Files]: {
		singularName: "document",
		pluralName: "documents",
	},
	[ArtifactType.Recordings]: {
		singularName: "video",
		pluralName: "videos",
	},
};

export function getArtifactTypeConfig(artifactType: ArtifactType): ArtifactTypeConfig {
	return artifactConfigs[artifactType];
}

export async function deleteArtifacts(
	artifactType: ArtifactType,
	selectedIds: string[],
	artifacts: Artifact[]
): Promise<Artifact[]> {
	if (selectedIds.length === 0) {
		return artifacts;
	}

	const artifactsToDelete = artifacts
		.filter((x) => selectedIds.includes(x.id))
		.map((x) => ({ id: x.id, conversationId: x.conversationId }));

	await api.deleteArtifacts(artifactType, artifactsToDelete);
	return artifacts.filter((x) => !selectedIds.includes(x.id));
}

export async function shareArtifact(artifactId: string, type: ArtifactType, context: any, toastHandler: any) {
	let result;
	if (type === ArtifactType.Recordings) {
		let meetingId, conversationId;

		if (context.conversation) {
			// ConversationPage context
			meetingId = context.conversation.meetingId;
			conversationId = context.conversation.id;
		} else {
			// ProjectPage context
			const recording = context.recordings.find((x) => x.id == artifactId);
			conversationId = recording.conversationId;
			const recordingConversation = context.recordingConversations.find((x) => x.id == conversationId);
			meetingId = recordingConversation.meetingId;
		}

		result = await api.getRecordingShareUrl({
			recordingId: artifactId,
			meetingId,
			conversationId,
		});
	} else if (type === ArtifactType.Snapshots) {
		let conversationId;

		if (context.conversation) {
			conversationId = context.conversation.id;
		} else {
			const snapshot = context.snapshots.find((x: any) => x.id == artifactId);
			conversationId = snapshot.conversationId;
		}

		result = await api.getSnapshotShareUrl({
			snapshotId: artifactId,
			conversationId,
		});
	}

	const shortUrl = result.url;

	if (navigator.clipboard) {
		try {
			await navigator.clipboard.writeText(shortUrl);
			const message = `The ${
				type === ArtifactType.Recordings ? "video" : "photo"
			} link has been copied to the clipboard.`;
			toastHandler.success(message, { timeout: calculateTimeout(message) });
		} catch (err) {
			const errorToast = toastHandler.info(
				{
					component: ClipboardWarning,
					props: {
						url: shortUrl,
						artifactType: type === ArtifactType.Recordings ? "video" : "photo",
						onClose: () => {
							toastHandler.dismiss(errorToast);
						},
					},
				},
				{
					timeout: 10000,
					draggable: false,
				}
			);
			console.error(
				`Failed to copy the ${type === ArtifactType.Recordings ? "video" : "photo"} link to the clipboard.`,
				err
			);
		}
	}
}
